export const currentBrandKeys = {
  all: ['currentBrand'] as const,
  detail: (brandId: string | null | undefined) => ['currentBrand', brandId] as const,
};
